export default __webpack_public_path__ + "static/media/H0002.ce956d82.png";